// Mock data for Ozzlabs clone

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Technologies', href: '#technologies' },
  { label: 'Contact', href: '#contact' },
];

export const heroStats = [
  { value: '500+', label: 'Projects Delivered' },
  { value: '50+', label: 'AI Solutions' },
  { value: '100+', label: 'Gaming Platforms' },
  { value: '24/7', label: 'Support' },
];

export const services = [
  {
    id: 'ai-software',
    title: 'AI Software Development',
    description: 'Custom AI solutions powered by machine learning and deep learning technologies.',
    icon: 'Brain',
    gradient: 'from-sky-500 to-indigo-600',
    features: ['Machine Learning Models', 'Neural Networks', 'Predictive Analytics', 'Automation Systems'],
  },
  {
    id: 'image-processing',
    title: 'Image Processing AI',
    description: 'Advanced computer vision and image analysis solutions for various industries.',
    icon: 'ImageIcon',
    gradient: 'from-fuchsia-500 to-pink-600',
    features: ['Object Recognition', 'Image Enhancement', 'Medical Imaging', 'Quality Control'],
  },
  {
    id: 'seo-writing',
    title: 'SEO Writing AI',
    description: 'Intelligent content generation and optimization for maximum search visibility.',
    icon: 'FileText',
    gradient: 'from-emerald-500 to-teal-600',
    features: ['Content Generation', 'SEO Optimization', 'Keyword Analysis', 'Content Strategy'],
  },
  {
    id: 'news-writing',
    title: 'News Writing AI',
    description: 'Automated news generation and content creation for media organizations.',
    icon: 'Newspaper',
    gradient: 'from-orange-500 to-amber-600',
    features: ['Real-time News', 'Content Curation', 'Multi-language Support', 'Fact Checking'],
  },
  {
    id: 'marketing-ai',
    title: 'Marketing AI',
    description: 'Intelligent marketing automation and customer engagement solutions.',
    icon: 'TrendingUp',
    gradient: 'from-violet-500 to-purple-600',
    features: ['Campaign Optimization', 'Customer Segmentation', 'Predictive Analytics', 'ROI Tracking'],
  },
  {
    id: 'gaming-systems',
    title: 'Gaming Systems',
    description: 'Cutting-edge gaming platforms and interactive entertainment solutions.',
    icon: 'Gamepad2',
    gradient: 'from-rose-500 to-red-600',
    features: ['Game Development', 'Multiplayer Systems', 'VR/AR Integration', 'Cloud Gaming'],
  },
  {
    id: 'gaming-software',
    title: 'Gaming Software',
    description: 'Mobile and desktop gaming applications with immersive experiences.',
    icon: 'Smartphone',
    gradient: 'from-cyan-500 to-blue-600',
    features: ['Mobile Games', 'Desktop Applications', 'Cross-platform', 'Real-time Multiplayer'],
  },
  {
    id: 'igaming',
    title: 'iGaming Platforms',
    description: 'Secure and scalable online gaming and betting platform solutions.',
    icon: 'ShieldCheck',
    gradient: 'from-yellow-500 to-orange-600',
    features: ['Secure Transactions', 'Live Gaming', 'Multi-currency', 'Compliance Ready'],
  },
  {
    id: 'payments',
    title: 'Payment Systems',
    description: 'Robust and secure payment processing solutions for global transactions.',
    icon: 'CreditCard',
    gradient: 'from-lime-500 to-green-600',
    features: ['Global Payments', 'Fraud Detection', 'Multi-currency', 'API Integration'],
  },
];

export const aboutStats = [
  { value: '15+', label: 'Years Experience' },
  { value: '10+', label: 'Happy Clients' },
];

export const aboutHighlights = [
  {
    title: 'Industry Leader',
    description: 'Recognized as a top technology innovator in AI and gaming solutions.',
    icon: 'Award',
  },
  {
    title: 'Expert Team',
    description: '20+ skilled developers, AI specialists, and technology experts.',
    icon: 'Users',
  },
  {
    title: 'Global Reach',
    description: 'Serving clients across 5+ countries with 24/7 support.',
    icon: 'Globe',
  },
  {
    title: 'Innovation First',
    description: 'Constantly pushing boundaries with cutting-edge technology solutions.',
    icon: 'Rocket',
  },
];

export const techCategories = [
  {
    title: 'AI & Machine Learning',
    icon: 'Brain',
    color: 'from-sky-400 to-cyan-400',
    tags: ['TensorFlow', 'PyTorch', 'OpenAI GPT', 'Computer Vision', 'Natural Language Processing', 'Deep Learning', 'Neural Networks', 'Reinforcement Learning'],
  },
  {
    title: 'Gaming & Graphics',
    icon: 'Gamepad2',
    color: 'from-fuchsia-400 to-pink-400',
    tags: ['Unity 3D', 'Unreal Engine', 'WebGL', 'Three.js', 'Blender', 'Maya', 'Photon', 'Mirror Networking'],
  },
  {
    title: 'Web & Mobile',
    icon: 'Smartphone',
    color: 'from-emerald-400 to-teal-400',
    tags: ['React', 'Vue.js', 'Node.js', 'React Native', 'Flutter', 'TypeScript', 'GraphQL', 'Progressive Web Apps'],
  },
  {
    title: 'Backend & Infrastructure',
    icon: 'Server',
    color: 'from-orange-400 to-amber-400',
    tags: ['AWS', 'Google Cloud', 'Docker', 'Kubernetes', 'MongoDB', 'PostgreSQL', 'Redis', 'Microservices'],
  },
  {
    title: 'Payment & Security',
    icon: 'ShieldCheck',
    color: 'from-violet-400 to-purple-400',
    tags: ['Stripe', 'PayPal', 'Blockchain', 'Cryptocurrency', 'OAuth', 'JWT', 'SSL/TLS', 'PCI Compliance'],
  },
  {
    title: 'Data & Analytics',
    icon: 'BarChart3',
    color: 'from-cyan-400 to-blue-400',
    tags: ['Apache Spark', 'Elasticsearch', 'Tableau', 'Power BI', 'Apache Kafka', 'Hadoop', 'Data Warehousing', 'ETL Pipelines'],
  },
];

export const techStats = [
  { value: '15+', label: 'Technologies Mastered' },
  { value: '10+', label: 'AI Models Deployed' },
  { value: '20+', label: 'Games Developed' },
  { value: '99.9%', label: 'System Uptime' },
];

export const serviceOptions = [
  'AI Software Development',
  'Image Processing AI',
  'SEO Writing AI',
  'Gaming Systems',
  'Payment Solutions',
  'Custom Development',
];

export const whyChoose = [
  'Expert team with 10+ years experience',
  'Cutting-edge technology solutions',
  '24/7 support and maintenance',
  'Proven track record of success',
];
